import React, { forwardRef, useImperativeHandle, useState, useRef } from 'react';
import { observer } from 'mobx-react';
import Snackbar from './simpleComponents/Snackbar';
const CMSSnackbar = observer( /*#__PURE__*/forwardRef(({
  className = '',
  closeOnAction = true,
  actionButtonText = 'Chiudi'
}, ref) => {
  const snackbarRef = useRef(null);
  const [type, setType] = useState('success');
  const SNACKBAR_TYPES = {
    error: {
      icon: 'cross-white',
      iconColor: '#B03E3E'
    },
    warning: {
      icon: 'cross-black',
      iconColor: '#F1C40F'
    },
    success: {
      icon: 'check-white',
      iconColor: '#1C8576'
    }
  };

  // per usarlo come riferimento
  useImperativeHandle(ref, () => ({
    showSnackbar: (type = 'error', textToShow = null, timeMs = -1) => {
      setType(type);
      snackbarRef.current.showSnackbar(textToShow, timeMs);
    },
    hideSnackbar: () => {}
  }));
  return /*#__PURE__*/React.createElement(Snackbar, {
    ref: snackbarRef,
    className: className,
    closeOnAction: closeOnAction,
    actionButtonText: actionButtonText,
    icon: SNACKBAR_TYPES[type].icon,
    iconColor: SNACKBAR_TYPES[type].iconColor
  });
}));
export default CMSSnackbar;